import type { ReactNode } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { CONFIG } from "@/config";

const Auth0ProviderWithHistory = ({ children }: { children: ReactNode }) => {
  return (
    <Auth0Provider
      domain={CONFIG.Auth0Domain}
      clientId={CONFIG.Auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: CONFIG.Auth0Audience,
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
